export default {
	PlaceableObject: foundry?.canvas?.placeables?.PlaceableObject ?? PlaceableObject,
	Token: foundry?.canvas?.placeables?.Token ?? Token,
	MeasuredTemplate: foundry?.canvas?.placeables?.MeasuredTemplate ?? MeasuredTemplate,
	Drawing: foundry?.canvas?.placeables?.Drawing ?? Drawing,
	Tile: foundry?.canvas?.placeables?.Tile ?? Tile,
	SpriteMesh: foundry?.canvas?.containers?.SpriteMesh ?? SpriteMesh,
	InteractionLayer: foundry?.canvas?.layers?.InteractionLayer ?? InteractionLayer,
	srcExists: foundry?.canvas?.srcExists ?? srcExists,
	loadTexture: foundry?.canvas?.loadTexture ?? loadTexture,
	BatchShaderGenerator: foundry?.canvas?.rendering?.batching?.BatchShaderGenerator ?? BatchShaderGenerator,
	BaseSamplerShader: foundry?.canvas?.rendering?.shaders?.BaseSamplerShader ?? BaseSamplerShader,
	AbstractBaseFilter: foundry?.canvas?.rendering?.filters?.AbstractBaseFilter ?? AbstractBaseFilter,
	CanvasAnimation: foundry?.canvas?.animation?.CanvasAnimation ?? CanvasAnimation,
	Canvas: foundry?.canvas?.Canvas ?? Canvas,
}